import { useState } from "react";
import GradientButton from "../../UI/buttonUI/GradientButton";
import GrayButton from "../../UI/buttonUI/GrayButton";
import Modal from "../../portal/Modal";
import usePostData from "../../../CustomHooks/useAxios/usePostData";
import { EXPENSE_REMARK } from "../../../api/allApi_List";
import ErrorDisplay from "../../UI/ErrorDisplay";

export const CheckSingleExpenseConfirmDialog = ({
  buttonStatus,
  closeDialog,
  checkLoading,
  handleCheck,
  expenseId,
}) => {
  const [remark, setRemarks] = useState("");
  const { executePost, loading, successResponse, formError, setFormError } =
    usePostData();

  const message = buttonStatus
    ? "Are you sure you want to Accept this expense ?"
    : "Are you sure you want to Reject this expense ?";

  const addRemark = () => {
    //API calling
    if (remark) {
      executePost({ id: expenseId[0], remark: remark }, EXPENSE_REMARK);
    }
  };

  return (
    <Modal
      onClose={closeDialog}
      modalWidth="flex-center-align dialogBoxWrap"
      closeIcon={true}
    >
      <div className="px-8 2xs:max-sm:px-0">
        {formError && (
          <ErrorDisplay
            message={formError}
            closeAction={() => setFormError("")}
          />
        )}
        <p className="dialogBoxMsg">{message}</p>
        {/* Show when remark is added successfully and button status false or reject  */}
        {!successResponse && !buttonStatus && (
          <textarea
            placeholder="Enter a remark"
            className="border-1 border-gray-300 px-2 rounded-md mt-2 w-full focus-input"
            onChange={(e) => setRemarks(e.target.value)}
          />
        )}
        {successResponse && (
          <p className="text-green">
            Remark successfully added! Please confirm that you want to reject
            this expense.
          </p>
        )}
        <div className="flex-center-align sm:mt-10 mt-4 gap-2">
          {(successResponse || buttonStatus) && (
            <GradientButton
              btnText={!checkLoading ? "Confirm" : "Loading..."}
              onClick={!checkLoading ? handleCheck : undefined}
            />
          )}
          {/* Show Add remark when remark is added successfully and button status false or reject  */}
          {!successResponse && !buttonStatus && (
            <GradientButton
              btnText={!loading ? "Add Remark" : "Adding..."}
              onClick={!loading ? addRemark : undefined}
            />
          )}
          <GrayButton btnText="Cancel" onClick={closeDialog} />
        </div>
      </div>
    </Modal>
  );
};
